<template lang="pug">
  div(class="organization-sign-preview")
    div(class="organization-sign-preview__top-label")
      div(class="text-12px fw-300 color-primary") {{ $t('Like this recipient will see it') }}
    div(class="organization-sign-preview__content")
      div(class="d-flex align-center justify-space-between")
        h1(class="title-32px fw-700 mb-2") {{ $t('Sign document') }}
        v-btn(
          icon
          @click="closeModal(false)"
          class="organization-sign-preview__close-btn"
        )
          e-svg-icon(
            name="close"
            size="lg"
          )
      div(class="text-14px fw-300 mb-8") {{ $t('Select signature method') }}
      div(
        v-for="signatureMethod in signatureMethods"
        :key="signatureMethod.key"
        class="organization-sign-preview__signature-method"
      )
        div(class="organization-sign-preview__signature-method-left")
          div(class="organization-sign-preview__signature-method-icon")
            v-img(
              :src="signatureMethod.icon"
              :max-width="40"
            )
          div(class="organization-sign-preview__signature-method-content")
            div(class="text-16px fw-500 dark") {{ signatureMethod.name }}
            div(v-if="!xsDevice" class="text-14px fw-300") {{ signatureMethod.description }}
        div(class="organization-sign-preview__signature-method-right")
          v-btn(icon)
            div(class="text-16px dark") →
</template>

<script>
import responsive from '~/mixins/pages/responsive'
export default {
  name: 'BlockOrganizationSignPreview',
  mixins: [responsive],
  props: {
    closeModal: {
      type: Function,
      default: () => { }
    },
    signatureMethods: {
      type: Array,
      default: () => []
    }
  }
}
</script>

<style lang="scss" scoped>
.organization-sign-preview {
  &__top-label {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 36px;
    background: $primary-light;
  }

  &__content {
    padding: 24px 40px 40px 40px;
  }

  &__signature-method {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 24px;
    background: $background-gray;
    border-radius: 16px;

    &:not(:last-child) {
      margin-bottom: 12px;
    }
  }

  &__signature-method-left {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__close-btn {
    width: 40px;
    height: 40px;
    border-radius: 12px !important;
    background: rgba(0, 0, 0, 0.03) !important;
    position: absolute;
    top: 60px;
    right: 20px;
  }
}
</style>
